export default __webpack_public_path__ + "static/media/18.f90b9379.jpg";